module.exports = __webpack_public_path__ + "static/media/nbr2.6276115b.png";